import {
  CodeBracketIcon,
  GlobeAltIcon,
  LinkIcon,
  FingerPrintIcon,
  Cog6ToothIcon,
  SparklesIcon,
  SwatchIcon,
  UserGroupIcon,
  CreditCardIcon,
  TrashIcon,
  UserIcon,
  FolderIcon,
  KeyIcon,
  BuildingOfficeIcon,
  UsersIcon,
  ArrowRightStartOnRectangleIcon,
  AdjustmentsHorizontalIcon
} from '@heroicons/vue/24/outline'
import { ROUTES } from '@/router/routeNames'

export const useProfileNavigation = () => {
  const { canAccess } = usePermissionStore()
  const { isLegacyBilling } = storeToRefs(useSubscriptionStore())
  const agencyStore = useAgencyStore()
  const isAgency = computed(() => agencyStore.isAgency)

  return computed(() => [
    { name: 'Profile', type: 'divider' as const },
    {
      name: 'Personal & Password',
      to: { name: ROUTES.PROFILE_PERSONAL },
      icon: UserIcon
    },
    {
      name: 'Owned Projects',
      to: { name: ROUTES.PROFILE_PROJECTS },
      icon: FolderIcon
    },
    {
      name: 'AI Connections',
      to: { name: ROUTES.PROFILE_AI_CONNECTIONS },
      icon: SparklesIcon
    },

    {
      name: 'API Tokens',
      to: { name: ROUTES.PROFILE_API_TOKENS },
      icon: KeyIcon
    },
    ...(isAgency.value
      ? [
          { name: 'Agency', type: 'divider' as const },
          {
            name: 'Agency Settings',
            to: { name: ROUTES.PROFILE_AGENCY_SETTINGS },
            icon: BuildingOfficeIcon
          },
          {
            name: 'Agency Clients',
            to: { name: ROUTES.PROFILE_AGENCY_CLIENTS },
            icon: UsersIcon
          }
        ]
      : []),
    ...(canAccess('manage-billing') && isLegacyBilling.value
      ? [
          { name: 'Billing', type: 'divider' as const },
          {
            name: 'Billing & Invoices',
            to: { name: ROUTES.PROFILE_BILLING },
            icon: CreditCardIcon
          }
        ]
      : []),
    { name: '', type: 'divider' as const },
    {
      name: 'Sign out',
      icon: ArrowRightStartOnRectangleIcon,
      href: '/logout'
    }
  ])
}

export const useSettingsNavigation = () => {
  const { canAccess } = usePermissionStore()
  const { isPerTeamBilling } = storeToRefs(useSubscriptionStore())

  return computed(() => [
    { name: 'Project', type: 'divider' as const },
    {
      name: 'General',
      to: { name: ROUTES.SETTINGS_OPTIONS },
      icon: Cog6ToothIcon
    },
    {
      name: 'Domains',
      to: { name: ROUTES.SETTINGS_DOMAINS },
      icon: GlobeAltIcon
    },
    {
      name: 'JavaScript Snippet',
      to: { name: ROUTES.SETTINGS_SNIPPET },
      icon: CodeBracketIcon
    },
    {
      name: 'Integration',
      to: { name: ROUTES.INTEGRATIONS },
      icon: LinkIcon
    },
    {
      name: 'Attribution',
      to: { name: ROUTES.ATTRIBUTION },
      icon: FingerPrintIcon
    },
    { name: 'Settings', type: 'divider' as const },
    {
      name: 'AI Settings',
      to: { name: ROUTES.SETTINGS_AI },
      icon: SparklesIcon
    },
    {
      name: 'Powered By',
      to: { name: ROUTES.SETTINGS_BRANDING },
      icon: SwatchIcon
    },
    {
      name: 'Advanced',
      to: { name: ROUTES.SETTINGS_ADVANCED },
      icon: AdjustmentsHorizontalIcon
    },
    { name: 'Account', type: 'divider' as const },
    ...(canAccess('manage-collaborators')
      ? [
          {
            name: 'Collaborators',
            to: { name: ROUTES.SETTINGS_COLLABORATORS },
            icon: UserGroupIcon
          }
        ]
      : []),
    ...(canAccess('manage-billing') && isPerTeamBilling.value
      ? [
          {
            name: 'Billing',
            to: { name: ROUTES.SETTINGS_BILLING },
            icon: CreditCardIcon
          }
        ]
      : []),
    ...(canAccess('reset-data')
      ? [
          {
            name: 'Your Data',
            to: { name: ROUTES.SETTINGS_DATA },
            icon: TrashIcon
          }
        ]
      : [])
  ])
}
